import { IonButton, IonContent, IonPage, IonToggle } from "@ionic/react";
import { useState } from "react";
import { useHistory } from "react-router";
import { updateAccount } from "../lib/firebase";
import { useAuthStore } from "../stores/auth.store";
import { useUsersStore } from "../stores/users.store";

type Props = {
  onDismiss: () => void;
};
const Notifications: React.FC<Props> = props => {
  const history = useHistory();
  const auth = useAuthStore(state => state.user);
  const user = useUsersStore(state => state.user);
  const [receiveNews, setReceiveNews] = useState(
    user?.notificationPreferences?.receiveNews || false
  );
  const [receiveNotifications, setReceiveNotifications] = useState(
    user?.notificationPreferences?.receiveNotifications || false
  );

  const toggleNotifications = async () => {
    if (!auth?.uid) {
      return;
    }
    const newReceiveNotification = !receiveNotifications;
    const data = {
      notificationPreferences: {
        receiveNews,
        receiveNotifications: newReceiveNotification
      }
    };
    await updateAccount(auth?.uid, data);
    setReceiveNotifications(newReceiveNotification);
    dismiss();
  };

  const dismiss = () => {
    if (props.onDismiss) {
      props.onDismiss();
    } else {
      history.replace("/dashboard");
    }
  };

  const skipNotifications = async () => {
    if (auth?.uid) {
      const data = {
        notificationPreferences: {
          receiveNews,
          receiveNotifications
        }
      };
      await updateAccount(auth?.uid, data);
    }
    dismiss();
  };

  return (
    <IonPage>
      <IonContent fullscreen>
        <div className="font-base text-4xl mt-24 ml-6 mr-24 mb-9 text-white">
          Notifications help you!
        </div>
        <p className="mx-6 text-lg text-primary-10">
          Turn on notifications to ensure you're on top of your game. We'll send
          you Trade details, and Bot Progress!
        </p>
        <div className="flex items-center justify-between my-16 mx-6 text-primary-10">
          <span className="w-[20ch]">Send me the latest QuidPro news</span>
          <div>
            <IonToggle
              checked={receiveNews}
              onIonChange={e => setReceiveNews(e.detail.checked)}
            ></IonToggle>
          </div>
        </div>

        <IonButton
          expand="block"
          color="primary"
          className="w-40 mx-6 mt-8 mb-4 h-12 normal-case"
          onClick={toggleNotifications}
        >
          {receiveNotifications ? "Pause Notifications" : "Yes, Notify me"}
        </IonButton>
        <IonButton
          expand="block"
          fill="outline"
          className="my-0 mx-6 w-40 h-12 normal-case"
          onClick={skipNotifications}
        >
          Skip
        </IonButton>
      </IonContent>
    </IonPage>
  );
};

export default Notifications;
